module.exports = "pegasus_template/assets/themecapture1/small/53.png";